var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12799 12.7321C1.67176 9.7666 1.21554 6.80117 0.759311 3.83567C0.658136 3.1783 1.40611 2.72995 1.93816 3.12902C3.35956 4.19507 4.78089 5.26105 6.20229 6.3271C6.67029 6.6781 7.33704 6.56387 7.66149 6.07712L11.2115 0.752122C11.5866 0.189397 12.4134 0.189397 12.7886 0.752122L16.3385 6.07712C16.663 6.56387 17.3297 6.67802 17.7977 6.3271C19.2191 5.26105 20.6405 4.19507 22.0619 3.12902C22.5939 2.72995 23.3419 3.1783 23.2408 3.83567C22.7846 6.80117 22.3283 9.7666 21.8721 12.7321H2.12799Z",
    fill: "#FFB743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8427 17.6676H3.15737C2.58887 17.6676 2.12799 17.2067 2.12799 16.6382V14.377H21.8721V16.6382C21.872 17.2067 21.4112 17.6676 20.8427 17.6676Z",
    fill: "#FFB743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer_1.5175fe1b8a06b910a57b1b2fb0db9af0.svg";
export { ForwardRef as ReactComponent };